import { MapboxFeature } from 'services/mapboxGeocoding';

export const formatAddressText = (feature: MapboxFeature) => {
  // Extract different parts of the address for better formatting
  const context = feature.context || [];
  const region = context.find((c) => c.id.includes('region'))?.text;
  const postcode = context.find((c) => c.id.includes('postcode'))?.text;
  const country = context
    .find((c) => c.id.includes('country'))
    ?.short_code?.toUpperCase();
  const addressNumber = feature.address || feature.properties?.address;

  let formatted = addressNumber
    ? `${addressNumber} ${feature.text}`
    : feature.text;

  if (region) {
    formatted += `, ${region}`;
  }

  if (postcode) {
    formatted += ` ${postcode}`;
  }

  if (country) {
    formatted += `, ${country}`;
  }

  return formatted;
};
